import { createSelector } from "@reduxjs/toolkit";
import isEmpty from "lodash/isEmpty";
import uniqBy from "lodash/uniqBy";
import groupBy from "lodash/groupBy";
import { RootState } from "../../redux/store";
import { Brand } from "../../services/brandsService";
import { BrandData } from "./types";

export const selectBrandsData = createSelector(
  (store: RootState) => store.brandsReducer.brands,
  data => {
    if (isEmpty(data)) return [];

    const categories = uniqBy(data, "category.value").map(brand => ({
      name: brand.category.value,
      slug: brand.category.key
    }));

    const brandsData: BrandData[] = categories.map(category => {
      const categoryBrands = uniqBy(
        data.filter(brand => brand.category.value === category.name),
        "brand.value"
      );

      const groupedBrands = groupBrands(categoryBrands);

      return {
        name: category.name,
        slug: category.slug,
        brands: groupedBrands
      };
    });

    const allCategoryBrands = uniqBy(data, "brand.value");

    brandsData.unshift({
      name: "All",
      slug: "All",
      count: allCategoryBrands.length,
      brands: groupBrands(allCategoryBrands)
    });

    return brandsData;
  }
);

const groupBrands = (categoryBrands: Brand[]) => {
  categoryBrands.sort((brand1, brand2) => {
    const name1 = brand1.brand.value.toLowerCase();
    const name2 = brand2.brand.value.toLowerCase();

    if (name1 < name2) {
      return -1;
    }
    if (name1 > name2) {
      return 1;
    }

    return 0;
  });

  return groupBy(categoryBrands, brand => brand.brand.value[0]?.toUpperCase());
};
